//import { installDatadogLogger } from '@/plugins/log';
import { router } from '@/router';
import 'flag-icons/css/flag-icons.min.css';
import { OhVueIcon, addIcons } from 'oh-vue-icons';
import {
  BiArrowThroughHeartFill,
  BiFileRichtext,
  BiListUl,
  BiStars,
  FaBook,
  FaBookReader,
  FaFemale,
  FaMale,
  GiCastle,
  GiDramaMasks,
  GiFamilyHouse,
  GiHeavyFighter,
  GiLightBackpack,
  GiMaterialsScience,
  GiMayanPyramid,
  GiThreeFriends,
  GiTurtle,
  GiWhiteBook,
  HiArrowLeft,
  HiBookOpen,
  HiCheckCircle,
  HiHome,
  HiSolidChevronLeft,
  HiSolidChevronRight,
  HiSolidSearch,
  HiSolidX,
  MdTheatercomedy,
  MdTune,
  OiFilter,
  OiPersonFill,
  PiWeedle,
  RiBookMarkFill,
  RiBookReadFill,
  RiStarFill,
  RiStarHalfFill,
  RiStarLine,
} from 'oh-vue-icons/icons';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import i18n from './plugins/i18n';
import './styles/base.css';
import './styles/tailwind.css';

addIcons(
  HiBookOpen,
  MdTune,
  PiWeedle,
  HiSolidSearch,
  HiArrowLeft,
  HiCheckCircle,
  BiListUl,
  HiHome,
  RiBookReadFill,
  RiBookMarkFill,
  BiStars,
  FaBook,
  FaBookReader,
  GiCastle,
  GiHeavyFighter,
  MdTheatercomedy,
  GiFamilyHouse,
  GiMaterialsScience,
  GiLightBackpack,
  GiThreeFriends,
  BiFileRichtext,
  OiPersonFill,
  GiMayanPyramid,
  HiSolidChevronRight,
  HiSolidChevronLeft,
  HiSolidX,
  OiFilter,
  BiArrowThroughHeartFill,
  GiDramaMasks,
  GiTurtle,
  GiWhiteBook,
  FaMale,
  FaFemale,
  RiStarLine,
  RiStarFill,
  RiStarHalfFill,
);

const app = createApp(App);
app.component('v-icon', OhVueIcon);
app.use(createPinia()).use(router).use(i18n).mount('#app');
//installDatadogLogger(app);
